import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { TypedUseSelectorHook, useSelector, useDispatch } from 'react-redux';

import localizationReducer from './features/localization/localizationSlice';
import momentReportsReducer from './features/moments-reports/momentReportsSlice';
import momentsReducer from './features/moments/momentsSlice';
import profileReducer from './features/profile/profileSlice';
import usersReducer from './features/user/usersSlice';

export const store = configureStore({
    reducer: {
        moments: momentsReducer,
        users: usersReducer,
        profile: profileReducer,
        localization: localizationReducer,
        momentReports: momentReportsReducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
